export default {
    placeholders: {
        destination: 'جستجوی مقصد یا هتل (داخلی و خارجی)',
    },
    city_hotels: 'هتل‌های {city}',
    hotel_reserve: 'رزرو هتل',
};
